import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Animacao } from '../../core/tools/animacao';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

/* Services */

import { OrcamentoService, OrcamentosPagedRequest } from '../../core/services/orcamentos/orcamento.service';
import { OrcamentoItensService } from '../../core/services/orcamentos/orcamento-itens.service';
import { PdfService } from '../../core/tools/pdf.service';
import { RelatoriosService, ExportarPedidosRequest } from '../../core/services/relatorios/relatorios.service';
import { PedidoService } from '../../core/services/pedidos/pedido.service';
import { PedidoStatusService } from '../../core/services/pedidos/pedido-status.service';
import { PrazoMedioService } from '../../core/services/prazos-medio/prazo-medio.service';

/* Models */

import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { OrcamentoItensSintetico } from '../../core/models/orcamentos/orcamento-itens-sintetico';
import { OrcamentoSintetico } from '../../core/models/orcamentos/orcamento-sintetico';
import { Pedido } from '../../core/models/pedidos/pedido';
import { PedidoBonificacaoRetorno } from '../../core/models/pedidos/pedido-bonificacao-retorno';
import { PedidoStatus } from '../../core/models/pedidos/pedido-status';
import { PrazoMedio } from '../../core/models/prazos-medio/prazo-medio';
import { PrazoMedioDesconto } from '../../core/models/prazos-medio/prazo-medio-desconto';

@Component({
    selector: 'app-pedidos-pendencias',
    templateUrl: './pedidos-pendencias.component.html',
    styleUrls: ['./pedidos-pendencias.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class PedidosPendenciasComponent implements OnInit {
  /* Carregamento */

  carregando: boolean = false;
  excelExportando: boolean = false;
  excelDiretoriaExportando: boolean = false;

  /* Filtros */

  formFiltro: UntypedFormGroup;

  filtroOpcoes: any[] = [
    { texto: "Período (Criado)", valor: "0" },
    { texto: "Cliente", valor: "1" },
    { texto: "Nro Pedido", valor: "2" },
    { texto: "Status", valor: "3" }
  ];

  enviado: boolean = false;
  filtrado: boolean = false;

  /* Status */

  filtroStatus: any[] = [
    { texto: "Todos", valor: "Todos" },
    { texto: "Pendência", valor: "Pendência" },
    { texto: "Pendência OK", valor: "Pendência OK" },
    { texto: "Reprovado", valor: "Reprovado" }
  ];


  /* Paginação */

  page: number = 1;
  pageSize: number = 50;
  total: number = 0;
  totalPages: number = 0;

  /* Configurações */

  @Input() configuracao: Configuracao;

  /* Desconto Aplicado */

  porcentagemDescontoAplicado: number = null;

  porcentagemDescontoAplicadoErro: boolean = false;

  /* Desconto Simulado */

  porcentagemDescontoSimulado: number = null;

  porcentagemDescontoSimuladoErro: boolean = false;

  /* Fator Financeiro */

  exibirFatorFinanceiro: boolean = false;

  /* Orçamentos */

  orcamentos: OrcamentoSintetico[] = [];
  orcamentosOriginal: OrcamentoSintetico[] = [];

  orcamentoEnviado: boolean = false;

  /* Orçamentos Itens */

  orcamentosItens: OrcamentoItensSintetico[] = [];
  orcamentosItensBonificacao: OrcamentoItensSintetico[] = [];
  orcamentosItensEnviar: OrcamentoItensSintetico[] = [];
  orcamentosItensOriginal: OrcamentoItensSintetico[] = [];

  orcamentosItensSaldo: number = 0;

  itemExpandido: number = -1;

  /* Pedido Bonificação (Retorno) */

  pedidoBonificacaoRetorno: PedidoBonificacaoRetorno = null;

  /* Pedidos (Status) */

  pedidosStatus: PedidoStatus[] = [];

  /* Prazo Médio */

  prazoMedio: PrazoMedio = null;

  prazoMedioDesconto: PrazoMedioDesconto = null;

  /* Modal */

  @ViewChild("comBonificacao") comBonificacao: ElementRef;

  /* Storage */

  is_master: boolean = (localStorage.getItem("is_master") == "true");
  is_manager: boolean = (localStorage.getItem("is_manager") == "true");
  is_master_seller: boolean = (localStorage.getItem("is_master_seller") == "true");
  is_diretor: boolean = (localStorage.getItem("is_diretor") == "true");
  is_financeiro: boolean = (localStorage.getItem("is_financeiro") == "true");
  modelo_tela_ligacoes: number = parseInt(localStorage.getItem("modelo_tela_ligacoes"));

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private orcamentoItensService: OrcamentoItensService,
    private orcamentoService: OrcamentoService,
    private pedidoService: PedidoService,
    private pdfService: PdfService,
    private pedidoStatusService: PedidoStatusService,
    private prazoMedioService: PrazoMedioService,
    private relatoriosService: RelatoriosService
  ) { }

  ngOnDestroy() {
    this.modalService.dismissAll();
  }

  ngOnInit() {
    /* Filtros */

    this.formFiltro = this.formBuilder.group({
      filtro: ["0"],
      dt_inicial: ["", Validators.required],
      dt_final: ["", Validators.required],
      cliente: ["", Validators.required],
      nro_pedido: ["", Validators.required],
      status: ["Todos"],
      vendedor: [""]
    });

    this.organizarFiltro();

    this.carregarDados(true);
  }

  get f() {
    return this.formFiltro.controls;
  }

  /* Ações */

  alterar(id_pedido: number, seller_id: number) {
    this.router.navigate(["/pedidos-cadastro/" + id_pedido], {
      queryParams: {
        vendedor: seller_id
      }
    });
  }

  desativar(id_pedido: number, seller_id: number) {
    this.orcamentoService.desativar(id_pedido, seller_id).subscribe(
      () => { },
      error => { console.log("Erro: " + error) },
      () => {
        this.toastr.success("", "Pedido desativado com sucesso!");

        this.carregarDados(false);
      }
    );
  }

  duplicar(id_pedido: number, seller_id: number) {
    this.router.navigate(["/pedidos-cadastro/" + id_pedido], {
      queryParams: {
        duplicar: true,
        vendedor: seller_id
      }
    });
  }

  enviar(id_pedido: number, seller_id: number) {
    let pedidoBonificacaoRetorno: PedidoBonificacaoRetorno = null;

    let porcentagemDesconto = this.porcentagemDescontoAplicado == null ? 0 : this.porcentagemDescontoAplicado;

    this.pedidoService.enviar(id_pedido, seller_id, porcentagemDesconto).subscribe(
      pedidosBonificacoesRetorno => pedidoBonificacaoRetorno = pedidosBonificacoesRetorno,
      error => { console.log("Erro: " + error) },
      () => {
        this.toastr.success("", "Pedido enviado com sucesso!");

        if (this.pedidoBonificacaoRetorno != null && this.pedidoBonificacaoRetorno.numero_pedido_bonificado != 0 && this.pedidoBonificacaoRetorno.valor_pedido_bonificado != 0) {
          this.modalComBonificacao(this.comBonificacao, this.pedidoBonificacaoRetorno.numero_pedido_bonificado, seller_id);
        }

        this.carregarDados(false);
      }
    );
  }

  /* Dados */

  buildPagedRequest(): OrcamentosPagedRequest {
    const f = this.formFiltro.controls;
    const req: OrcamentosPagedRequest = {
      page: this.page,
      pageSize: this.pageSize,
      sort: 'order_created_at',
      direction: 'desc'
    };

    const rawIni = f['dt_inicial'].value;
    const rawFin = f['dt_final'].value;

    if (rawIni && rawIni.year) {
      req.dataInicio = this.datePipe.transform(new Date(rawIni.year, rawIni.month - 1, rawIni.day), 'yyyy-MM-dd');
    }
    if (rawFin && rawFin.year) {
      req.dataFim = this.datePipe.transform(new Date(rawFin.year, rawFin.month - 1, rawFin.day), 'yyyy-MM-dd');
    }

    if (f['cliente'].value) { req.cliente = f['cliente'].value.trim(); }
    if (f['nro_pedido'].value) { req.nroPedido = f['nro_pedido'].value; }
    if (f['status'].value && f['status'].value !== 'Todos') { req.status = f['status'].value; }
    if (f['vendedor'].value) { req.vendedor = f['vendedor'].value.trim(); }

    return req;
  }

  carregarDados(inicial: boolean) {
    this.carregando = true;
    this.itemExpandido = -1;

    const req = this.buildPagedRequest();

    this.orcamentoService.getPendenciasPaged(req).subscribe(
      result => {
        this.orcamentos = result.items;
        this.total = result.total;
        this.totalPages = Math.ceil(result.total / this.pageSize);
      },
      error => { console.log('Erro: ' + error); this.carregando = false; },
      () => {
        this.carregando = false;
      }
    );
  }

  onPageChange(p: number) {
    this.page = p;
    this.carregarDados(false);
  }

  onPageSizeChange(n: number) {
    this.pageSize = n;
    this.page = 1;
    this.carregarDados(false);
  }

  /* Desconto Aplicado / Prazo Médio / Pedido Bonificação (Retorno) */

  calcularSaldo(id_pedido: number, seller_id: number, seller_id_client: number) {
    if (this.configuracao != null && this.configuracao.usa_conta_corrente_flex) {
      let calcularSaldo: boolean;

      this.pedidoService.calcularSaldo(id_pedido, seller_id_client, seller_id).subscribe(
        calcularSaldos => calcularSaldo = calcularSaldos,
        error => { console.log("Erro: " + error) },
        () => {
          if (calcularSaldo) {
            this.toastr.success("", "Saldo calculado com sucesso!");

            this.enviar(id_pedido, seller_id);
          } else {
            this.toastr.error("", "Saldo inválido!");
          }
        }
      );
    } else {
      this.enviar(id_pedido, seller_id);
    }
  }

  carregarDadosEnviar(recarregando: boolean, orcamentoEnviar: OrcamentoSintetico) {
    let retorno = new Promise((resolver) => {
      if (recarregando) {
        return resolver("recarregando");
      } else {
        this.prazoMedio = null;

        this.prazoMedioDesconto = null;

        this.pedidoBonificacaoRetorno = null;

        if (this.configuracao != null && this.configuracao.usar_desconto_prazo_medio == "S") {
          this.prazoMedioService.getByIdPrazoPagamento(orcamentoEnviar.id_prazo_pagamento).subscribe(
            prazoMedio => this.prazoMedio = prazoMedio,
            error => { console.log("Erro: " + error) },
            () => {
              this.orcamentoItensService.get15DiasByOrder(orcamentoEnviar.order_id_app, orcamentoEnviar.seller_id).subscribe(
                orcamentosItens => this.orcamentosItensEnviar = orcamentosItens,
                error => { console.log("Erro: " + error) },
                () => {
                  let valorTotalPadrao = this.orcamentosItensEnviar.reduce((sum, current) => (sum + (current.quantity * current.price)), 0);
                  let valorTotalAdicionado = this.orcamentosItensEnviar.reduce((sum, current) => (sum + (current.quantity * current.unit_price)), 0);

                  if (valorTotalAdicionado >= valorTotalPadrao) {
                    this.prazoMedioService.getPrazoMedioDescontoByGuidClienteNapis(this.prazoMedio.prazomedio).subscribe(
                      prazoMedioDesconto => this.prazoMedioDesconto = prazoMedioDesconto,
                      error => { console.log("Erro: " + error) },
                      () => {
                        return resolver("com_modal");
                      }
                    );
                  } else {
                    return resolver("fora_tabela");
                  }
                }
              );
            }
          );
        } else {
          return resolver("enviar");
        }
      }
    });

    return retorno;
  }

  validarDescontoAplicado() {
    if (this.prazoMedioDesconto != null) {
      if (this.porcentagemDescontoAplicado > this.prazoMedioDesconto.percentual_desconto) {
        this.porcentagemDescontoAplicadoErro = true;
      } else {
        this.porcentagemDescontoAplicadoErro = false;
      }
    } else {
      this.porcentagemDescontoAplicadoErro = true;
    }
  }

  /* Desconto Simulado */

  limparDescontoSimulado() {
    this.porcentagemDescontoSimulado = null;

    this.porcentagemDescontoSimuladoErro = false;
  }

  validarDescontoSimulado() {
    if (this.porcentagemDescontoSimulado > 100) {
      this.porcentagemDescontoSimuladoErro = true;
    } else {
      this.porcentagemDescontoSimuladoErro = false;
    }
  }

  /* Expandir */

  expandir(i: number, id: number, seller_id: number) {
    this.exibirFatorFinanceiro = false;

    this.itemExpandido = i == this.itemExpandido ? -1 : i;

    this.orcamentosItensSaldo = 0;

    if (this.itemExpandido > -1) {
      this.orcamentoItensService.get15DiasByOrder(id, seller_id).subscribe(
        orcamentosItens => this.orcamentosItens = orcamentosItens,
        error => { console.log("Erro: " + error) },
        () => {
          if (this.orcamentosItens.length > 0) {
            this.orcamentosItensBonificacao = this.orcamentosItens.filter(orcamentoItem => !orcamentoItem.is_active);

            this.orcamentosItens = this.orcamentosItens.filter(orcamentoItem => orcamentoItem.is_active);

            this.orcamentosItensSaldo = this.orcamentosItens.reduce((sum, current) => sum + current.valor_desconto, 0);

            this.orcamentosItensOriginal = JSON.parse(JSON.stringify(this.orcamentosItens));

            let qtdeProdutosFatorFinanceiro: number = this.orcamentosItens.filter(orcamentoItem => orcamentoItem.fator_financeiro != null && orcamentoItem.fator_financeiro != 0).length;

            if (qtdeProdutosFatorFinanceiro > 0) {
              this.exibirFatorFinanceiro = true;
            }

          } else {
            this.orcamentosItensOriginal = [];
          }
        }
      );
    }
  }

  /* Status UI */

  isItemPendente(item: OrcamentoItensSintetico): boolean {
    return item.estoque_disponivel != null && item.estoque_disponivel < item.quantity;
  }

  /* Filtros */

  alterarFiltro(filtro_selecionado: string) {
    let filtroAtual: string = this.formFiltro.controls["filtro"].value;

    this.formFiltro.reset();

    if (filtro_selecionado == null) {
      this.formFiltro.controls["filtro"].setValue(filtroAtual);
    } else {
      this.formFiltro.controls["filtro"].setValue(filtro_selecionado);
    }

    this.formFiltro.controls["status"].setValue("Todos");

    this.organizarFiltro();

    this.enviado = false;
    this.filtrado = false;
  }

  filtrar(formulario: boolean) {
    if (formulario) {
      this.enviado = true;

      if (this.formFiltro.invalid) {
        return;
      }
    }

    this.filtrado = true;
    this.page = 1;
    this.carregarDados(false);
  }

  organizarFiltro() {
    if (this.formFiltro.controls["filtro"].value == "0") {
      this.formFiltro.get("dt_inicial").enable();
      this.formFiltro.get("dt_final").enable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("nro_pedido").disable();
      this.formFiltro.get("status").disable();
    } else if (this.formFiltro.controls["filtro"].value == "1") {
      this.formFiltro.get("dt_inicial").disable();
      this.formFiltro.get("dt_final").disable();
      this.formFiltro.get("cliente").enable();
      this.formFiltro.get("nro_pedido").disable();
      this.formFiltro.get("status").disable();
    } else if (this.formFiltro.controls["filtro"].value == "2") {
      this.formFiltro.get("dt_inicial").disable();
      this.formFiltro.get("dt_final").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("nro_pedido").enable();
      this.formFiltro.get("status").disable();
    } else if (this.formFiltro.controls["filtro"].value == "3") {
      this.formFiltro.get("dt_inicial").disable();
      this.formFiltro.get("dt_final").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("nro_pedido").disable();
      this.formFiltro.get("status").enable();
    }
  }

  /* Formatação */

  formatarValoresQuatroCasasDecimais(valor: number) {
    if (valor != null) {
      return (valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 4
      });
    }
  }

  /* Modal */

  modalComBonificacao(content: any, numero_pedido_bonificado: number, seller_id: number) {
    this.modalService.open(content, {
      ariaLabelledBy: "titulo-com-bonificacao",
      size: "lg",
      backdrop: "static"
    }).result.then((acao) => {
      if (acao == "Sim") {
        this.router.navigate(["/pedidos-cadastro/" + numero_pedido_bonificado], {
          queryParams: {
            vendedor: seller_id
          }
        });
      }
    }, () => {

    });
  }

  modalDescontoSimulado(content: any, id_pedido: number, seller_id: number) {
    this.modalService.open(content, {
      ariaLabelledBy: "titulo-desconto-simulado",
      size: "lg",
      backdrop: "static"
    }).result.then((acao) => {
      if (acao == "Prosseguir") {
        if (this.porcentagemDescontoSimuladoErro) {
          this.toastr.error("", "Desconto inválido!");

          this.modalDescontoSimulado(content, id_pedido, seller_id);
        } else {
          this.pdfService.imprimirPedidoOrcamento(id_pedido, seller_id, this.porcentagemDescontoSimulado);

          this.limparDescontoSimulado();
        }
      } else {
        this.limparDescontoSimulado();
      }
    }, () => {
      this.limparDescontoSimulado();
    });
  }

  modalPedidoEnviar(content: any, id_pedido: number, seller_id: number, seller_id_client: number, recarregando: boolean) {
    let pedido: Pedido = null;

    this.pedidoService.getByOrder(id_pedido, seller_id).subscribe(
      pedidos => pedido = pedidos,
      error => { console.log("Erro: " + error) },
      () => {
        if (pedido.order_sent_on == null) {
          let orcamentoEnviar = this.orcamentos.find(orcamento => orcamento.order_id_app == id_pedido);

          if (orcamentoEnviar != null && orcamentoEnviar.id_prazo_pagamento != null) {
            let comModal: boolean = false;

            const carregarDadosEnviar = this.carregarDadosEnviar(recarregando, orcamentoEnviar);

            carregarDadosEnviar.then((resolver) => {
              if (resolver == "com_modal") {
                comModal = true;
              } else if (resolver == "enviar") {
                this.calcularSaldo(id_pedido, seller_id, seller_id_client);
              } else if (resolver == "fora_tabela") {
                this.toastr.warning("", "Pedido fora da tabela padrão...");

                this.calcularSaldo(id_pedido, seller_id, seller_id_client);
              } else if (resolver == "recarregando") {
                comModal = true;
              }

              if (comModal) {
                this.modalService.open(content, {
                  ariaLabelledBy: "titulo-pedido-enviar",
                  size: "lg",
                  backdrop: "static"
                }).result.then((acao) => {
                  if (acao == "Enviar") {
                    if (this.porcentagemDescontoAplicadoErro) {
                      this.toastr.error("", "Desconto Aplicado inválido!");

                      this.modalPedidoEnviar(content, id_pedido, seller_id, seller_id_client, true);
                    } else {
                      this.calcularSaldo(id_pedido, seller_id, seller_id_client);
                    }
                  }
                }, () => {

                });
              }
            });
          } else {
            if (orcamentoEnviar != null) {
              this.toastr.info("", "Confirme as informações p/ envio!");

              this.router.navigate(["/pedidos-cadastro/" + orcamentoEnviar.order_id_app], {
                queryParams: {
                  vendedor: orcamentoEnviar.seller_id
                }
              });
            }
          }
        } else {
          this.toastr.info("", "Tente novamente...");

          this.carregarDados(false);
        }
      }
    );
  }

  modalPedidoStatus(content: any, id_pedido: number) {
    this.pedidoStatusService.getPedidoStatusByOrder(id_pedido).subscribe(
      pedidosStatus => this.pedidosStatus = pedidosStatus,
      error => { console.log("Erro: " + error) },
      () => {
        this.modalService.open(content, {
          ariaLabelledBy: "titulo-pedido-status",
          size: "lg",
          backdrop: "static"
        });
      }
    );
  }

  /* Exportar Excel */

  private buildExportPayload(tipoRelatorio: string): ExportarPedidosRequest {
    const req = this.buildPagedRequest();
    return {
      userId: parseInt(localStorage.getItem('id'), 10),
      tipoRelatorio,
      tela: 'PENDENCIAS',
      dataInicio: req.dataInicio || null,
      dataFim:    req.dataFim    || null,
      cliente:    req.cliente    || null,
      nroPedido:  req.nroPedido  ? +req.nroPedido : null,
      status:     req.status     || null,
      vendedor:   req.vendedor   || null,
      filtrarB2B:       false,
      filtrarCancelado: false
    };
  }

  exportarExcel() {
    if (this.orcamentos.length === 0 || this.excelExportando) { return; }
    this.excelExportando = true;
    const payload = this.buildExportPayload('GERAL');
    this.relatoriosService.exportarExcel(payload).subscribe(
      blob => {
        if (blob) {
          const sufixo = payload.dataInicio
            ? `${payload.dataInicio.replace(/-/g,'')}_${(payload.dataFim || '').replace(/-/g,'')}`
            : new Date().toISOString().slice(0, 10).replace(/-/g, '');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url; a.download = `pedidos-pendencias-geral_${sufixo}.xlsx`; a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      error => { console.error('Erro ao exportar Excel', error); },
      ()    => { this.excelExportando = false; }
    );
  }

  exportarExcelDiretoria() {
    if (this.orcamentos.length === 0 || this.excelDiretoriaExportando) { return; }
    this.excelDiretoriaExportando = true;
    const payload = this.buildExportPayload('DIRETORIA');
    this.relatoriosService.exportarExcel(payload).subscribe(
      blob => {
        if (blob) {
          const sufixo = payload.dataInicio
            ? `${payload.dataInicio.replace(/-/g,'')}_${(payload.dataFim || '').replace(/-/g,'')}`
            : new Date().toISOString().slice(0, 10).replace(/-/g, '');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url; a.download = `pedidos-pendencias-diretoria_${sufixo}.xlsx`; a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      error => { console.error('Erro ao exportar Excel Diretoria', error); },
      ()    => { this.excelDiretoriaExportando = false; }
    );
  }
}
